<template>
    <div>
        <loading-custom :loading="loading" />
        <div
            class="modal"
            id="manageStock"
            tabindex="-1"
            role="dialog"
            v-if="product && product.name"
        >
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="modal-title" id="manageStockLabel">
                            <h5 class="mb-0 tw-font-bold">
                                เพิ่ม - ลด จำนวนสินค้า
                            </h5>
                        </div>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <div class="tw-flex tw-flex-col tw-p-5">
                            <div class="tw-flex tw-justify-evenly tw-flex-col md:tw-flex-row">
                                <div class="tw-flex md:tw-w-1/2 tw-w-full">
                                    <div>
                                        <img
                                            class="product_img"
                                            :src="product.image_url"
                                            alt=""
                                        />
                                    </div>
                                    <div class="tw-flex tw-flex-col tw-ml-2">
                                        <div>
                                            <h5>
                                                {{ product.name }}
                                            </h5>
                                        </div>
                                        <div class="tw-text-xs tw-text-gray-400">{{ product.description }}</div>
                                        <div>
                                            {{
                                                `${Number(
                                                    product.price
                                                ).toLocaleString(undefined, {
                                                    minimumFractionDigits: 2
                                                })} ${currency.name}`
                                            }}
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="tw-border-r-2 tw-border-l-0 tw-border-t-0 md:tw-border-b-0 tw-border-b-2  tw-border-solid tw-border-gray-500 md:tw-my-0 tw-my-5"
                                ></div>
                                <div class="tw-flex tw-flex-col md:tw-w-1/2 tw-w-full">
                                    <h5 class="tw-text-center">
                                        จำนวนคงเหลือในคลัง
                                    </h5>
                                    <h1 class="tw-text-center">
                                        {{ product.stock_balance }}
                                    </h1>
                                </div>
                            </div>
                            <div
                                class="tw-flex tw-justify-evenly tw-mt-5 manage-stock__contain"
                            >
                                <div class="tw-flex tw-flex-1 tw-px-2 tw-justify-center tw-mb-5">
                                    <button
                                        @click="changeStatus(form, 'status', 'stock_in')"
                                        :class="`toggle-btn-increase ${form.status === 'stock_in' ? 'toggle-btn-increase__active' : ''}`">
                                        เพิ่ม
                                    </button>
                                    <button
                                        @click="changeStatus(form, 'status', 'stock_out')"
                                        :class="`toggle-btn-reduce ${form.status === 'stock_out' ? 'toggle-btn-reduce__active' : ''}`">
                                        ลด
                                    </button>
                                </div>
                                <div
                                    class="tw-flex tw-items-center tw-justify-center tw-flex-1 tw-px-2"
                                >
                                    <div class="tw-text-black tw-text-xl">
                                        จำนวนสินค้า :
                                    </div>
                                    <input
                                        v-model="form.quantity"
                                        type="number"
                                        min="0"
                                        :max="
                                            form.status == 'stock_out'
                                                ? product.stock_balance
                                                : ''
                                        "
                                        class="quantity_stock"
                                    />
                                </div>
                                <div class="tw-flex tw-items-center tw-justify-center tw-flex-1 tw-px-2 mt-3">
                                    <textarea 
                                        v-model="form.remark"
                                        class="tw-border-transparent p-2"
                                        name="remark" 
                                        id="remark" 
                                        cols="50" 
                                        rows="5"
                                        placeholder="หมายเหตุ"
                                    ></textarea>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-sm btn-default px-3"
                            data-dismiss="modal"
                        >
                            ยกเลิก
                        </button>
                        <button
                            type="button"
                            class="btn btn-sm btn-success px-3"
                            data-dismiss="modal"
                            :disabled="!form.quantity || form.quantity <= 0"
                            @click="store"
                        >
                            อัพเดท
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["productId", "product", "shop"],
    data() {
        return {
            form: {
                remark: "",
                status: "stock_in"
            },
            conditionAttr: {
                max: this.product.stock_balance
            },
            loading: false
        };
    },
    watch: {
        productId(val) {
            this.getData();
            this.getCurrency();
        }
    },
    methods: {
        changeStatus(data, props, value) {
            data[props] = value;
        },
        getData() {
            this.form.product_id = this.productId;
        },
        onUpdate() {
            this.form = {
                status: "stock_in",
                product_id: this.productId
            };
            this.$emit("onUpdate", "success");
        },
        async store() {
            this.loading = true;
            await axios
                .post(`/backend/s/${this.shop}/stocks`, this.form)
                .then(res => {
                    if (res.data.status == "success") {
                        this.onUpdate();
                    } else if (res.data.status == "error") {
                        this.$swal({
                            icon: "error",
                            title: "เกิดข้อผิดพลาด",
                            text: "จำนวนในสต็อกไม่พอ ไม่สามารถเอาออกได้",
                            showConfirmButton: true
                        });
                    }

                    this.loading = false;
                })
                .catch(err => {
                    this.messageAlert(
                        "error",
                        "Sorry",
                        "กรุณาใส่ข้อมูลให้ครบถ้วน"
                    );
                });
        },
        async getCurrency() {
            this.loading = true;
            await axios
                .get(`/ajax/frontend/s/${this.shop}/currency`)
                .then(res => {
                    this.currency = res.data.currency;
                })
                .catch(err => {
                    console.log(err.response.data);
                })
                .then(() => {
                    this.loading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped>
#manageStock {
    .product_img {
        width: 100px;
    }
}
.manage-stock__contain {
    flex-flow: column;
    justify-content: center;
    background: #f1f1f1;
    padding: 20px;
}
.toggle-btn-increase {
    width: 200px;
    background: #fff;
    color: #000;
    cursor: pointer;
    height: 40px;
    margin: 10px;
    border: none;
    border-radius: 4px;
    font-size: 15px;
    cursor: pointer;

    &__active {
        background: #119b00;
        color: #ffffff;
    }
}
.toggle-btn-reduce {
    width: 200px;
    background: #fff;
    color: #000;
    cursor: pointer;
    height: 40px;
    margin: 10px;
    border: none;
    border-radius: 4px;
    font-size: 15px;
    cursor: pointer;

    &__active {
        background: #db2727;
        color: #ffffff;
    }
}
.quantity_stock {
    width: 200px;
    border: none;
    border-bottom: 1px solid #000000;
    background: transparent;
    color: rgb(0, 0, 0);
    text-align: center;
    font-size: 26px;
    font-weight: bold;

    @media (min-width: 0px) and (max-width: 992px) {
         width: 150px;
    }
    &:focus {
        background: transparent;
        text-decoration: none;
        outline: none;
    }
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type="number"] {
    -moz-appearance: textfield;
}
textarea {
  resize: none;
}
</style>
